import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for PW98M5 (人事資料核准沖銷)
// ============================================================

export type SubFormType = 'fa' | 'fc' | 'fd' | 'fg';

export const SUB_FORM_LABELS: Record<SubFormType, string> = {
  fa: '人事增補沖銷 (FA)',
  fc: '離職申請沖銷 (FC)',
  fd: '資遣通知沖銷 (FD)',
  fg: '留職停薪沖銷 (FG)',
};

export interface ReverseCandidate {
  doc_no: string;          // 申請單號
  applicant_id: string;    // 申請人員工代碼
  applicant_name: string;  // 申請人姓名
  dept_code: string;       // 部門代碼
  dept_name: string;       // 部門名稱
  apply_date: string;      // 申請日期
  status: string;          // 核准狀態
  sub_form: SubFormType;   // 所屬子表單類型
}

export interface QueryResponse {
  items: ReverseCandidate[];
  total: number;
  sub_form: SubFormType;
}

export interface ReverseResponse {
  success: number;
  failed: number;
  errors?: string[];
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const pw98m5Api = {
  /** Query HR application candidates eligible for reversal */
  async queryCandidates(
    subForm: SubFormType,
    startNo: string,
    endNo: string
  ): Promise<QueryResponse> {
    const params: Record<string, string> = { sub_form: subForm };
    if (startNo.trim()) params['start'] = startNo.trim();
    if (endNo.trim()) params['end'] = endNo.trim();
    const res = await apiClient.get('/api/pw98m5/candidates', { params });
    return res.data;
  },

  /** Execute batch reversal for selected HR application records */
  async reverse(
    subForm: SubFormType,
    items: string[]
  ): Promise<ReverseResponse> {
    const res = await apiClient.post('/api/pw98m5/reverse', {
      sub_form: subForm,
      items,
    });
    return res.data;
  },
};
